<template>
    <b-container class="event-detail-wrapper" v-if="event">
        <b-row :class="['event-title-wrapper', {'with-underline': !noUnderline}]">
            <b-col cols="12" md="6" :class="['event-title', 'font-size-65', 'text-left']" v-html="event.name">
                {{event.name}}
            </b-col>
            <b-col cols="12" md="6" :class="['event-title', 'font-size-65', 'text-right', 'event-status']" v-if="eventStatusLabel">
                {{eventStatusLabel}}
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="eventIsOld"
                   :class="['event-detail', 'text-left', {'with-border': !noBorder}]">
                <b-row v-for="key in Object.keys(oldEventDescriptions)" v-if="oldEventDescriptions[key]">
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.'+key)}}</b-col>
                    <b-col class="event-detail-field-content" sm="9">{{oldEventDescriptions[key]}}</b-col>
                </b-row>
                <b-row class="event-detail-btns">
                    <b-col sm="12" md="6">
                        <b-row>
                            <b-button class="event-detail-download-poster-btn"
                                      block=""
                                      @click="downloadPoster()"
                                      v-if="event.poster">
                                <font-awesome-icon icon="download"></font-awesome-icon>
                                {{$t('event.download_poster')}}
                            </b-button>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-if="!eventIsOld"
                   :class="['event-detail', 'text-left', {'with-border': !noBorder}]">
                <b-row>
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.date')}}</b-col>
                    <b-col class="event-detail-field-content" sm="9">
                        <!--By Event-->
                        <b-row v-if="event.signup_mode === -1 || event.signup_mode === 1" class="mb-0">
                            <b-col>
                                {{eventDateLabel(event)}}
                            </b-col>
                        </b-row>
                        <!--{{event.signup_mode === 0 || event.signup_mode === 1 ? eventDateLabel(event) : null}}-->

                        <!--By Session-->
                        <b-row v-for="session in event.sessions" v-if="event.signup_mode === 2 && event.sessions.length !== 0" :key="session.id">
                            <b-col cols="2" v-if="canEnroll">
                                <b-form-radio :name="event.id"
                                              :value="session.id"
                                              v-model="selectedId"></b-form-radio>
                            </b-col>
                            <b-col>{{sessionLabel(session)}} {{session.quota === -1 ? "" : $t('event.quota_template', {quota: session.quota})}}</b-col>
                        </b-row>

                        <!--By Series-->
                        <b-row v-for="series in event.series" v-if="event.signup_mode === 3 && event.series.length !== 0" :key="series.id">
                            <b-col cols="2" v-if="canEnroll">
                                <b-form-radio :name="event.id"
                                              :value="series.id"
                                              v-model="selectedId"></b-form-radio>
                            </b-col>
                            <b-col>
                                <b-row>
                                    <b-col><b>{{series.name}} {{series.quota === -1 ? "" : $t('event.quota_template', {quota: series.quota})}}</b></b-col>

                                </b-row>
                                <b-row v-for="session in sortedSessions(series)" :key="session.id" class="mb-1">
                                    <b-col>{{sessionLabelWithoutName(session)}}</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row v-if="event.signup_mode === -1 || event.signup_mode === 0">
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.time')}}</b-col>
                    <b-col class="event-detail-field-content" sm="9">{{eventTimeLabel(event)}}</b-col>
                </b-row>
                <b-row>
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.location')}}</b-col>
                    <b-col class="event-detail-field-content" sm="9">{{event.location}}</b-col>
                </b-row>
                <b-row v-if="event.quota !== -1">
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.quota')}}</b-col>
                    <b-col class="event-detail-field-content" sm="9">{{event.quota}}</b-col>
                </b-row>
                <b-row v-if="eventLanguageLabel(event)">
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.languages')}}</b-col>
                    <b-col class="event-detail-field-content" sm="9">{{eventLanguageLabel(event)}}</b-col>
                </b-row>
                <b-row>
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.fee')}}</b-col>
                    <!--Free-->
                    <b-col class="event-detail-field-content" sm="9"
                           v-if="eventFeeTiers(event).length === 0">{{$t('event.free')}}
                    </b-col>
                    <!--Fixed Fee-->
                    <b-col class="event-detail-field-content" sm="9"
                           v-if="eventFeeTiers(event).length > 0 && !eventFeeTiers(event)[0].name">
                        HKD {{eventFeeTiers(event)[0].fee}}
                    </b-col>
                    <!--By Tiers-->
                    <b-col class="event-detail-field-content" sm="9"
                           v-if="eventFeeTiers(event).length > 0 && eventFeeTiers(event)[0].name">
                        <b-row v-for="(tier, index) in eventFeeTiers(event)" v-if="canEnroll">
                            <b-col>{{tier.name ? tier.name + ": " : ""}} HKD {{tier.fee}}</b-col>
                            <b-col cols="3">
                                <b-form-select :id="event.id + '-enroll-count-' + index" :options="peopleCountOptions(tier.max)"></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row v-for="tier in eventFeeTiers(event)" v-if="!canEnroll">
                            <b-col>{{tier.name ? tier.name + ": " : ""}} HKD {{tier.fee}}</b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row v-if="event.remarks">
                    <b-col class="event-detail-field-header" sm="3">{{$t('event.remarks')}}</b-col>
                    <b-col class="event-detail-field-content" sm="9" v-html="event.remarks"></b-col>
                </b-row>
                <b-row class="event-detail-btns">
                    <b-col sm="12" md="6">
                        <b-row>
                            <b-button class="event-detail-download-poster-btn mb-3"
                                      block=""
                                      @click="downloadPoster()"
                                      v-if="event.poster">
                                <font-awesome-icon icon="download"></font-awesome-icon>
                                {{$t('event.download_poster')}}
                            </b-button>
                            <b-button class="event-detail-download-attachment-btn"
                                      block=""
                                      @click="downloadAttachment()"
                                      v-if="event.attachment_id">
                                <font-awesome-icon icon="download"></font-awesome-icon>
                                {{$t('event.download_attachment')}}
                            </b-button>
                        </b-row>
                    </b-col>
                    <b-col class="text-right" sm="12" md="6">
                        <b-row>
                            <b-button class="event-detail-past-moment-btn mb-3"
                                      block
                                      @click="showPastMoment()"
                                      v-if="event.memorable_moment_enabled && !hidePastMomentBtn">
                                {{$t('event.show_past_moment')}}
                            </b-button>
                            <b-button class="event-detail-enroll-btn mb-3"
                                      block
                                      @click="enrollClicked"
                                      v-if="canEnroll && !enrolled">
                                {{$t('event.enroll')}}
                            </b-button>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import $ from 'jquery'

    export default {
        name: 'EventDetail',
        props: {
            event: Object,
            hidePastMomentBtn: Boolean,
            canEnroll: Boolean,
            enrolled: Boolean,
            noBorder: Boolean,
            noUnderline: Boolean,
        },
        components: {},
        data() {
            return {
                selectedId: null,
            };
        },
        computed: {
            eventIsOld() {
                let start = DateTime.fromISO(this.event.start);

                return start.year === 2001;
            },
            oldEventDescriptions() {
                if (this.eventIsOld) {
                    return JSON.parse(this.event.description);
                } else {
                    return null;
                }
            },
            eventStatusLabel() {
                let eventEnd = DateTime.fromISO(this.event.end);

                if (eventEnd <= new Date()) {
                    return "(" + this.$t('event_status.ended') + ")";
                }

                let eventSignupUntil = DateTime.fromISO(this.event.signup_until);

                if (eventSignupUntil <= new Date()) {
                    return "(" + this.$t('event_status.enrollment_ended') + ")";
                }

                if (this.enrolled) {
                    return "(" + this.$t('event_status.enrolled') + ")";
                }
            },
            eventHasEnded() {
                let visibleUntil = DateTime.fromISO(this.event.visible_until);

                return new Date() > visibleUntil;
            },
        },
        methods: {
            eventFeeTiers(event) {
                return JSON.parse(event.fee_tiers || '[]');
            },
            eventDateLabel() {
                let date = DateTime.fromISO(this.event.date);
                let startTime = DateTime.fromISO(this.event.from_time);
                let endTime = DateTime.fromISO(this.event.to_time);

                return date.toFormat('yyyy-MM-dd');
            },
            eventTimeLabel(event) {
                let fromTime = DateTime.fromFormat(event.from_time, 'HH:mm:ss');
                let toTime = DateTime.fromFormat(event.to_time, 'HH:mm:ss');
                return fromTime.toFormat('HH:mm') + ' - ' + toTime.toFormat('HH:mm');
            },
            sortedSessions(series) {
                let sessions = Array.from(series.sessions);

                sessions.sort(function (a, b) {
                    if (a.start === b.start) {
                        return 0;
                    }

                    return (a.start > b.start) ? 1 : -1;
                });

                // sessions.sort(function (a, b) {
                //     if (a.name === b.name) {
                //         return 0;
                //     }
                //
                //     return (a.name > b.name) ? 1 : -1;
                // });

                return sessions;
            },
            sessionLabelWithoutName(session) {
                let start = DateTime.fromISO(session.start);
                let end = DateTime.fromISO(session.end);


                return start.toFormat('d/M/y, T') + " - " + end.toFormat('T');
            },
            sessionLabel(session) {
                let start = DateTime.fromISO(session.start);
                let end = DateTime.fromISO(session.end);

                return session.name + ": " + start.toFormat('d/M/y, T') + " - " + end.toFormat('T');
            },
            eventLanguageLabel() {
                let v = this;
                return JSON.parse(this.event.languages).map(function (l) {
                    return v.$t('languages.' + l);
                }).join(", ")
            },
            peopleCountOptions(max) {
                if (!max) {
                    max = 10;
                }

                let options = [];

                for (var i = 0; i <= max; i++) {
                    options.push({text: i, value: i})
                }

                return options;
            },
            downloadPoster() {
                window.open('/api/static/' + this.event.poster, '_blank');
            },
            downloadAttachment() {
                window.open('/api/static/' + this.event.attachment_id, '_blank');
            },
            showPastMoment() {
                this.$router.push({name: 'past-event-detail', params: {eventId: this.event.id}})
            },
            enrollMeta() {
                let v = this;
                let meta = {};
                let feeTiers = this.eventFeeTiers(this.event);

                feeTiers.forEach(function (t, index) {
                    let count = $('#' + v.event.id + '-enroll-count-' + index).val();

                    if (count && count !== '0') {
                        meta[t.name] = count;
                    }
                });

                return meta;
            },
            enrollClicked() {
                if (this.$store.state.user.id) {

                    let meta = this.enrollMeta();
                    let feeTiers = this.eventFeeTiers(this.event);

                    if (Object.keys(feeTiers).length > 1 && Object.keys(meta).length === 0) {
                        this.$showAlertMessage(this.$t('event.input_fee_msg'));
                        return;
                    }

                    this.$emit('enroll', {event: this.event, meta: meta});
                } else {
                    let v = this;
                    this.$showAlertMessage(this.$t('login_msg'), function () {
                        v.$router.push({name: 'login', query: {after: v.$route.path + encodeURI('?e=' + v.event.id)}})
                    });
                }
            },
        },
    }
</script>


<style lang="less">
    @media only screen and (max-width: 767px) {
        .event-status {
            text-align: left !important;
        }
    }

    .event-detail-wrapper {
        .event-title-wrapper {
            .event-title {
                font-weight: bold;
                padding-top: 20px;
            }

            &.with-underline {
                border-bottom: 2px solid;
            }
        }


        .event-detail {
            padding: 20px;

            &.with-border {
                border-left: 12px solid #edeced;
            }

            .row {
                margin-bottom: 15px;
            }

            .event-detail-title {
                font-size: 1.75rem;
                font-weight: bold;
                border-bottom: 2px solid;
                text-align: left;
            }

            .event-detail-field-header {
                font-weight: bold;
                text-align: left;
            }

            .event-detail-field-content {
                text-align: left;
            }

            .event-detail-description {
                text-align: initial !important;
                margin-bottom: 72px;
            }

            .event-detail-btns {
                bottom: 15px;
                right: 15px;

                button {
                    margin: 0 15px;
                }

                .event-detail-download-poster-btn {
                    background-color: #f99918;
                    color: white;
                    border: solid 3px #f99918;
                    border-radius: 0;

                    &:hover {
                        background-color: transparent;
                        color: #f99918;
                    }
                }

                .event-detail-download-attachment-btn {
                    background-color: #f99918;
                    color: white;
                    border: solid 3px #f99918;
                    border-radius: 0;

                    &:hover {
                        background-color: transparent;
                        color: #f99918;
                    }
                }

                .event-detail-past-moment-btn {
                    background-color: #34ace0;
                    color: white;
                    font-weight: bold;
                    border: solid 3px #34ace0;
                    border-radius: 0;

                    &:hover {
                        background-color: transparent;
                        color: #34ace0;
                    }
                }

                .event-detail-enroll-btn {
                    background-color: #34ace0;
                    color: white;
                    font-weight: bold;
                    border: solid 3px #34ace0;
                    border-radius: 0;

                    &:hover {
                        background-color: transparent;
                        color: #34ace0;
                    }
                }
            }
        }
    }
</style>